var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.555,5.842a4,4,0,0,1,6.891,0l16,27.126A4,4,0,0,1,39,39H7a4,4,0,0,1-3.445-6.032Z","transform":"translate(39) rotate(90)","fill":"#ffba00"}));
}

ChevronRight.defaultProps = {"width":"39","height":"46","viewBox":"0 0 39 46"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
